import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const contactAPI = {
  submit: async (formData) => {
    const response = await axios.post(`${API}/contact`, formData);
    return response.data;
  },
  getAll: async () => {
    const response = await axios.get(`${API}/contact`);
    return response.data;
  }
};

export const attestationsAPI = {
  create: async (reportData) => {
    const response = await axios.post(`${API}/attestations`, reportData);
    return response.data;
  },
  getAll: async () => {
    const response = await axios.get(`${API}/attestations`);
    return response.data;
  },
  delete: async (reportId) => {
    const response = await axios.delete(`${API}/attestations/${reportId}`);
    return response.data;
  }
};

export default { contactAPI, attestationsAPI };